import type { BackgroundJobStatus, BackgroundJobSummary } from '../../../shared/background-jobs';

const STATUS_ZH: Record<BackgroundJobStatus, string> = {
  queued: '等待中', collecting: '收集数据', snapshot: '冻结快照', rendering: '生成文件',
  packaging_media: '打包资料', checksum: '校验文件', complete: '已完成', failed: '需要处理', expired: '已过期'
};
const STATUS_EN: Record<BackgroundJobStatus, string> = {
  queued: 'Queued', collecting: 'Collecting', snapshot: 'Snapshot', rendering: 'Rendering',
  packaging_media: 'Packaging', checksum: 'Checksum', complete: 'Complete', failed: 'Needs attention', expired: 'Expired'
};

export function exportJobStatusLabel(status: BackgroundJobStatus, zh: boolean): string {
  return (zh ? STATUS_ZH : STATUS_EN)[status];
}

export function exportJobKindLabel(job: BackgroundJobSummary, zh: boolean): string {
  if (job.jobType === 'recipe_export') return zh ? '配方导出' : 'Recipe export';
  if (job.jobType === 'menu_prep_export') return zh ? '菜单备料汇总' : 'Menu prep summary';
  if (job.jobType === 'menu_production_export') return zh ? '菜单生产包' : 'Menu production pack';
  if (job.jobType === 'menu_dossier_export') return zh ? '菜单上线档案包' : 'Menu launch dossier';
  if (job.jobType === 'snapshot_render') return zh ? '快照重新生成' : 'Snapshot rerender';
  if (job.jobType === 'archive_export') return zh ? '完整媒体归档' : 'Full media archive';
  if (job.jobType === 'archive_restore_inspect') return zh ? '归档恢复检查' : 'Archive restore inspection';
  if (job.jobType === 'archive_restore_import') return zh ? '归档恢复导入' : 'Archive restore import';
  if (job.jobType === 'scope_export' && job.format === 'pdf' && job.targetType === 'dish_version') return zh ? '菜品 PDF' : 'Dish PDF';
  if (job.jobType === 'scope_export' && job.format === 'pdf') return zh ? '合并配方册' : 'Merged recipe book';
  if (job.jobType === 'scope_export') return zh ? '数据包' : 'Data bundle';
  return zh ? '后台导出' : 'Background export';
}

export function exportJobRetentionLabel(job: BackgroundJobSummary, zh: boolean): string {
  if (job.status === 'failed' && job.expiresAt) {
    return zh ? `可重试至 ${new Date(job.expiresAt).toLocaleString()}` : `Retry until ${new Date(job.expiresAt).toLocaleString()}`;
  }
  if (job.status === 'expired') return zh ? '重试窗口已过期，历史记录仍保留' : 'Retry window expired; history is retained';
  if (job.status === 'complete') return zh ? '冻结历史已保留' : 'Frozen history retained';
  return zh ? '后台任务记录会保留' : 'Background job history is retained';
}

export function exportJobFailureMessage(job: BackgroundJobSummary, zh: boolean): string {
  const shortId = job.id.length > 18 ? `${job.id.slice(0, 18)}…` : job.id;
  return zh
    ? `这次导出没有完成。任务记录仍保留，可以直接重试；如果持续失败，请提供任务编号 ${shortId}。`
    : `This export did not complete. The job record is retained and can be retried. If it keeps failing, provide job ID ${shortId}.`;
}
